import React from 'react';
import '../styles/Expertise.css';
import { Card } from './Card';

import tanuki_login from '../assets/projects/tanuki_login.png';
import tanuki_homepage from '../assets/projects/tanuki_homepage.png';
import tanuki_preview from '../assets/projects/tanuki_preview.png';
import quizzie_login from '../assets/projects/quizzie_login.png';
import quizzie_test from '../assets/projects/quizzie_test.png';
import quizzie_results from '../assets/projects/quizzie_results.png';
import slackr_login from '../assets/projects/slackr_login.png';
import slackr_channel from '../assets/projects/slackr_channel.png';
import slackr_create from '../assets/projects/slackr_create.png';
import ascent_home from '../assets/projects/ascent_home.png';
import ascent_car from '../assets/projects/ascent_car.png';
import ascent_puzzle from '../assets/projects/ascent_puzzle.png';

const Projects = ({ isDarkMode }) => {
    const infoClass = `expertise-content-info ${
        isDarkMode ? 'expertise-content-info-dark' : 'expertise-content-info-light'
    }`;
    const dividerClass = `expertise-division ${
        isDarkMode ? 'expertise-division-dark' : 'expertise-division-light'
    }`;
    return (
        <div className='expertise-container'>
            {/* Information section of expertise */}
            <div className={infoClass}>
                <div className="expertise-heading">
                    <h1>
                        Projects 🚀
                    </h1>
                </div>

                <div className={dividerClass} />

                <div className="expertise-content">
                    <p>
                    A curated collection of real-world and academic projects where I’ve applied my skills in  <span>software development</span>, <span style={{color: '#FF2D55'}}>UI/UX design</span>, and <span style={{color: '#32ADE6'}}>problem solving</span> — from web apps to backend systems. 
                    <br /> <br />
                    Each project reflects hands-on experience, teamwork, and a passion for building meaningful tech. 🚀✨
                    </p>
                </div>
            </div>

            {/* Project cards*/}
            <div className='project-card-container'>
                <Card 
                    isDarkMode={isDarkMode}
                    images={[tanuki_login, tanuki_homepage, tanuki_preview]}
                    title="UNSW Final Project: Tanuki"
                    description="Developed a responsive web application that streamlines e-invoice processing through PDF -> UBL conversion, validation, and API-based delivery."
                    badges={['React', 'JavaScript', 'CSS', 'Python', 'FastAPI', 'SQLite', 'Docker', 'API Integration']}
                />
                <Card 
                    isDarkMode={isDarkMode}
                    images={[quizzie_login, quizzie_test, quizzie_results]}
                    title="UNIHACK25: Quizzie"
                    description="Welcome to Quizzie, the test prep platform where students don’t just take tests—they create them. We also empower teachers to digitally create, examine and mark student's work on our one stop platform."
                    buttonLabel="Learn More"
                    onClick={() => window.open('https://devpost.com/software/quizzie-yoa84r', '_blank')}
                    badges={['TypeScript', 'Next.js', 'Node.js', 'Prisma', 'Supabase', 'Vercel', 'OpenAI API']}
                />
                <Card 
                    isDarkMode={isDarkMode}
                    images={[slackr_channel, slackr_login, slackr_create]}
                    title="UNSW COMP6080: Slackr"
                    description="Similar to Slack, Slackr is a real-time web application that enables users to create and join public or private channels, exchange messages, and manage their profiles. It supports channel-based collaboration, user authentication, and dynamic UI updates for a seamless team communication experience — all built with a modern frontend and a RESTful backend."
                    badges={['HTML', 'CSS', 'JavaScript', 'Python', 'FastAPI']}
                />
                <Card 
                    isDarkMode={isDarkMode}
                    images={[ascent_home, ascent_car, ascent_puzzle]}
                    title="UNSW COMP3421: Ascent"
                    description="A first-person puzzle-platformer where players ascend a mountain, solve challenges, and chase the sky - a journey blending calm, focus and adventure."
                    badges={['Unreal Engine 5']}
                />
            </div>
        </div>
    );
};

export default Projects;